import { render } from "./Edit.vue?vue&type=template&id=c87d1738"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Developer\\Desktop\\Company\\help-desk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__